import * as actions from './actions';

const initialState = 0;

export default function loadingReducer(state = initialState, action) {
  switch (action.type) {
    case actions.START_LOADING:
      return state + 1;

    case actions.FINISH_LOADING:
      return state > 0 ? state - 1 : 0;

    default:
      return state;
  }
}
